import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./sidebar.css";
import logoutIcon from "../../img/logout.png";
import userIcon from "../../img/User Management.svg";
import menuPermissionIcon from "../../img/menu-permission.svg";
import attendanceIcon from "../../img/Icons/attendance.webp";
import dashboardIcon from "../../img/Dashboard.svg";
import carIcon from "../../img/Vehicle Management.svg";
import vendorIcon from "../../img/Transporter Management.svg";
import siteIcon from "../../img/Site Management.svg";
import routeIcon from "../../img/Route Management.svg";
import tripIcon from "../../img/Trip Management.svg";
import myNewIcon from "../../img/Trip Management.svg";
// import dashboardIcon from '../../img/dashboard.png'
import reportIcon from "../../img/Reports.svg";
import GpsIcon from "../../img/GPS report.png";
import RunningIcon from "../../img/Running Report.png";
import StoppageIcon from "../../img/Stoppage report.png";
import AllTripIcon from "../../img/All trip report.png";
import SummaryIcon from "../../img/Summary report.png";
import DelayedIcon from "../../img/Delayed report.png";
import TemparingIcon from "../../img/Tempering report.png";
import OverSpeedIcon from "../../img/Over speed report.png";
import NearestVehicleIcon from "../../img/Nearest vehicle report.png";
import RouteDevationIcon from "../../img/Route Deviation report.png";
import TrackHistoryIcon from "../../img/Track History.svg";
import fuelDashboardIcon from "../../img/fueldashboard.png";
import fuelIcon from "../../img/FuelReport.png";
import fuelFillIcon from "../../img/Fuelfillreport.png";
import fuelDroppageIcon from "../../img/Fueldroppagereport.png";
import fuelmanagementIcon from "../../img/Fuel Management.svg";
import activeLogIcon from "../../img/Activelog.svg";
import activeRouteIcon from "../../img/ActiveRoutes.png";
import uptimeIcon from "../../img/Uptimereport.png";
import settingIcon from "../../img/Icons/settings.png";
import notificationIcon from "../../img/Notification Configuration.svg";
import DriverManagemenIcon from "../../img/Driver Management System.svg";
import FuelFillReport from "../../img/FeulReopts/Fuel Fill report.svg";
import FuelDroppageReport from "../../img/FeulReopts/Fuel Drop report.svg";
import GPSWirecutReport from "../../img/FeulReopts/GPS Wirecut Report.svg";
import FuelSensorWirecutReport from "../../img/FeulReopts/Fuel Sensor Wirecut Report.svg";
import FuelSummaryReport from "../../img/FeulReopts/Fuel Summary report.svg";
import FuelGraphMISReport from "../../img/FeulReopts/Fuel Graph MIS report.svg";
import AlertMISReport from "../../img/FeulReopts/Alert MIS Report.svg";
import FuelDeviationMaster from "../../img/FeulReopts/Deviation Master.svg";
import ReportSettingConfigIcon from "../../img/FeulReopts/Report configuration.svg";
import OffendedDriverIcon from "../../img/FeulReopts/Offened driver.svg";
import CalibrationIcon from "../../img/FeulReopts/Fuel Calibration Report.svg";
import manualFuelEventsIcon from "../../img/Manual Fuel event.svg";
import lockDashboardIcon from "../../img/operation-dashboard.png";
import LockInventory from "../../img/Lock Inventory 1.svg";
import NotificationsIcon from "@material-ui/icons/Notifications";
import companyIcon from "../../img/company.svg";
import { version } from "../../config/config";
import { ContactsOutlined } from "@material-ui/icons";
import { masterConfig } from "../../config/CompanyHeader";

function Sidebar() {
  const history = useHistory();
  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(localStorage.getItem("data")),
  );
  const [parentMenuColor, setParentMenuColor] = React.useState(false);
  const masterConfigrs = masterConfig();

  const viewAllUserPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "USER_MENU",
    );
  const viewAllSitePermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "SITE_MENU",
    );
  const viewAllRoutePermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "ROUTE_MENU",
    );
  const viewAllVehiclePermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VEHICLE_MENU",
    );
  const viewAllVendorPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VENDOR_MENU",
    );
  const viewAllTripPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ALL_TRIP",
    );

  const DriverManagement =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "DRIVER_MANAGEMENT_SYSTEM",
    );
  debugger;
  const DriverAttendance =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "DRIVER_ATTENDANCE_MENU",
    );

  const viewAllReportPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ALL_REPORT",
    );
  const viewAllReportAuditPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_AUDIT_LOG_REPORT",
    );
  const viewAllReportActiveRoutesPermission =
    permissionAccess &&
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ACTIVE_ROUTES",
    );

  let dashboardMenu = false;
  let userMenu = false;
  let companyMenu = false;
  let vendorMenu = false;
  let vehicleMenu = false;
  let siteMenu = false;
  let routeMenu = false;
  let trackMenu = false;
  let tripMenu = false;
  let reportMenu = false;
  let menuPermission = false;
  let fuelMenu = false;
  let fuelReport = false;
  let notificationMenu = false;
  let DriverManagementSystem = false;
  let sidemenu = false;
  let advanceSettings = false;
  let reportConfig = false;
  let devaitionDetails = false;
  let manualEvent = false;
  let attendance = false;
  let GeoFenceInoutReport = false;
  let LockDashboard = false;
  let lockInventory = false;
  let alertList = false;

  if (permissionAccess && permissionAccess.menuVisiblity) {
    permissionAccess &&
      permissionAccess.menuVisiblity.forEach((element) => {
        if (element.name == "DASHBOARD") {
          dashboardMenu = element.isVisible;
        }
        if (element.name == "LOCK_DASHBOARD") {
          LockDashboard = element.isVisible;
        }
        if (element.name == "LOCK_INVENTORY") {
          lockInventory = element.isVisible;
        }
        if (element.name == "ALERT_LIST") {
          alertList = element.isVisible;
        }

        if (element.name == "ADVANCE_SETTING") {
          advanceSettings = element.isVisible;
        }
        if (element.name == "USER_MANAGEMENT") {
          userMenu = element.isVisible;
        }
        if (element.name === "COMPANY_MANAGEMENT") {
          companyMenu = element.isVisible;
        }
        if (element.name == "TRANSPORTER_MANAGEMENT") {
          vendorMenu = element.isVisible;
        }
        if (element.name == "VEHICLE_MANAGEMENT") {
          vehicleMenu = element.isVisible;
        }
        if (element.name == "SITE_MANAGEMENT") {
          siteMenu = element.isVisible;
        }
        if (element.name === "ROUTE_MANAGEMENT") {
          if (permissionAccess?.companyId === 38) {
            routeMenu = false;
          } else {
            routeMenu = element.isVisible;
          }
        }
        if (element.name == "TRACK_HISTORY") {
          trackMenu = element.isVisible;
        }
        if (element.name == "TRIP_MANAGEMENT") {
          tripMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelReport = element.isVisible;
        }
        if (element.name == "MENU_PERMISSION") {
          menuPermission = element.isVisible;
        }
        if (element.name == "REPORTS") {
          reportMenu = element.isVisible;
        }
        if (element.name == "NOTIFICATION CONFIGURATION") {
          notificationMenu = element.isVisible;
        }
        if (element.name == "MENU_MANAGEMENT") {
          sidemenu = element.isVisible;
        }
        if (element.name == "REPORT CONFIGURATION") {
          reportConfig = element.isVisible;
        }
        if (element.name == "DEVIATION_MASTER") {
          devaitionDetails = element.isVisible;
        }
        if (element.name == "MANUAL_FUEL_EVENTS") {
          manualEvent = element.isVisible;
        }
        if (element?.name === "DRIVER_MANAGEMENT_SYSTEM") {
          DriverManagementSystem = element.isVisible;
        }
        if (element?.name === "DRIVER_ATTENDANCE") {
          attendance = element.isVisible;
        }
      });
  }

  // sub menu visibility Oct 13th 2022
  // for fuel management->fuelreports
  let fuelSummaryReport = true;
  let sensorCutVehicles = true;
  let fuelSensorWirecut = true;
  let fuelFillReport = true;
  let fuelDroppageReport = true;
  let gpsWirecutReport = true;
  let gpsEventReportsReport = true;
  let autoApprovalEventReports = true;
  let fuelGraphMisReport = true;
  let fuelEffiencyMisReport = true;
  let expectedVsActualReport = true;
  let fuelConsumptionReport = true;
  let fuelMisReport = true;
  let alertMisReport = true;
  let combineFuelReport = true;
  let dieselIssue = true;
  let deviceHavingIssued = true;
  let OffendedDriver = true;
  let fuelCalibartionReports = true;
  let consumptionReport = true;
  let eventAnlayzer = true;
  let dropageRegulator = true;

  //for reports
  let summaryReport = false;
  let movementReport = false;
  let dailyDistanceReopts = false;
  let stoppageReport = false;
  let overSpeedReport = false;
  let geofenceReport = false;
  let routeDeviationReport = false;
  let tamperingReport = false;
  let auditLog = false;
  let activeRoutes = false;
  let gpsReport = false;
  let equipmentUtilization = false;
  let equipmentReport = false;
  let dayEfficienlyReports = false;
  let EfficienlyReports = false;
  let weeklyEfficienlyReports = false;
  let LoadSensorReport = false;

  if (permissionAccess && permissionAccess.subMenuVisibilty) {
    permissionAccess &&
      permissionAccess.subMenuVisibilty.forEach((element) => {
        if (element.name === "FUEL_SUMMARY_REPORT") {
          fuelSummaryReport = element.isVisible;
        } else if (element.name === "SENSOR_CUT_VEHICLES") {
          sensorCutVehicles = element.isVisible;
        } else if (element.name === "FUEL_SENSOR_WIRECUT_REPORT") {
          fuelSensorWirecut = element.isVisible;
        } else if (element.name === "FUEL_FILL_REPORT") {
          fuelFillReport = element.isVisible;
        } else if (element.name === "FUEL_DROPPAGE_REPORT") {
          fuelDroppageReport = element.isVisible;
        } else if (element.name === "FUEL_WIRECUT_REPORT") {
          gpsWirecutReport = element.isVisible;
        } else if (element.name === "FUEL_EVENTAPPROVER_REPORT") {
          gpsEventReportsReport = element.isVisible;
        } else if (element.name === "AUTO_APPROVAL_EVENT_REPORT") {
          autoApprovalEventReports = element.isVisible;
        } else if (element.name === "FUEL_GRAPH_MIS_REPORT") {
          fuelGraphMisReport = element.isVisible;
        } else if (element.name === "FUEL_EFFICIENCY_MIS_REPORT") {
          // fuel spelling mistake in api
          fuelEffiencyMisReport = element.isVisible;
        } else if (element.name === "EXPECTED_VS_ACTUAL_REPORT") {
          expectedVsActualReport = element.isVisible;
        } else if (element.name === "FUEL_CONSUMPTION_REPORT") {
          fuelConsumptionReport = element.isVisible;
        } else if (element.name === "FUEL_MIS_REPORT") {
          fuelMisReport = element.isVisible;
        } else if (element.name === "ALERT_MIS_REPORT") {
          // - instead of _ in api
          alertMisReport = element.isVisible;
        } else if (element.name === "COMBINE_FUEL_REPORT") {
          combineFuelReport = element.isVisible;
        } else if (element.name === "DIESEL_ISSUE") {
          dieselIssue = element.isVisible;
        } else if (element.name === "DEVICE_HAVING_ISSUED") {
          deviceHavingIssued = element.isVisible;
        } else if (element.name === "OFFENDED_DRIVER") {
          OffendedDriver = element.isVisible;
        } else if (element.name === "FUEL_CALIBARTION_REPORT") {
          fuelCalibartionReports = element.isVisible;
        } else if (element.name === "EVENT_ANALYZER") {
          eventAnlayzer = element.isVisible;
        } else if (element.name === "DROPAGE_REGULATORY") {
          dropageRegulator = element.isVisible;
        }

        // else if (element.name === "CONSUMPTION_REPORT") {
        //   dieselIssue = element.isVisible;
        // }
        // for reports
        else if (element.name === "SUMMARY_REPORT") {
          summaryReport = element.isVisible;
        } else if (element.name === "MOVEMENT_REPORT") {
          movementReport = element.isVisible;
        } else if (element.name === "DAILY_DISTANCE") {
          dailyDistanceReopts = element.isVisible;
        } else if (element.name === "STOPPAGE_REPORT") {
          stoppageReport = element.isVisible;
        } else if (element.name === "OVER_SPEED_REPORT") {
          overSpeedReport = element.isVisible;
        } else if (element.name === "GEOFENCE_REPORT") {
          geofenceReport = element.isVisible;
        } else if (element.name === "ROUTE_DEVIATION_REPORT") {
          routeDeviationReport = element.isVisible;
        } else if (element.name === "TAMPERING_REPORT") {
          tamperingReport = element.isVisible;
        } else if (element.name === "AUDIT_LOG") {
          auditLog = element.isVisible;
        } else if (element.name === "ACTIVE_ROUTES") {
          activeRoutes = element.isVisible;
        } else if (element.name === "GPS_REPORT") {
          gpsReport = element.isVisible;
        } else if (element.name === "EQUIPMENT_UTILIZATION_REPORTS") {
          equipmentUtilization = element.isVisible;
        } else if (element.name === "EQUIPMENT_REPORTS") {
          equipmentReport = element.isVisible;
        } else if (element.name === "DAY_EFFICIENCY_REPORTS") {
          dayEfficienlyReports = element.isVisible;
        } else if (element.name === "EFFICIENCY_REPORTS") {
          EfficienlyReports = element.isVisible;
        } else if (element.name === "WEEKLY_EFFICIENCY_REPORTS") {
          weeklyEfficienlyReports = element.isVisible;
        } else if (element.name === "GEOFENCE_REPORTS") {
          GeoFenceInoutReport = element.isVisible;
        } else if (element.name === "BULKER_REPORTS") {
          LoadSensorReport = element.isVisible;
        }
      });
  }

  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.localStorage.clear();
  };

  const handleClick = (value) => {
    localStorage.removeItem("payloadForDroppage");
    localStorage.setItem("fuelDetailsState", JSON.stringify(false));
    // history.push(`/${value}`);
    window.open(`/${value}`, "_self");
  };

  const dmsHandleClick = async () => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    window.open(
      `https://dms.watsoo.com/dashboard?userData=${token}`,
      "_blanck",
    );
    // window.open(`http://localhost:3000/equpmentlocation?userData=${token}`, "_blanck");
    // window.open(`http://localhost:3000/equpmentlocation?companyId=${token?.companyId}&userId=${token.id}&show=${true}&name=${token.name}&userData=${token.token}`, "_blanck");
  };

  const mouseOutHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0]; //Fuel management
    let id2 = document.getElementsByClassName("dropdownFuel")[1]; // fuel management > Fuel report
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0]; // fuel management > Dashboard
    id1.classList.remove("my-class");
    id2.classList.remove("my-class");
    id3.classList.remove("my-class");
  };

  const mouseOverHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0];
    let id2 = document.getElementsByClassName("dropdownFuel")[1];
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0];

    id1.classList.add("my-class");
    id2.classList.add("my-class");
    id3.classList.add("my-class");
    setParentMenuColor(true);

    id2.addEventListener("mouseover", () => {
      id1.classList.add("my-class");
      const fuelReportSubmenusArray =
        document.getElementsByClassName("fuelReportSubmenu");
      for (const subMenuUnit of fuelReportSubmenusArray) {
        subMenuUnit.addEventListener("mouseover", () => {
          subMenuUnit.classList.add("my-class_with-border");
          id1.classList.add("my-class");
          id2.classList.add("my-class");
          id3.classList.add("my-class");
        });
        subMenuUnit.addEventListener("mouseout", () => {
          subMenuUnit.classList.remove("my-class_with-border");
          id1.classList.remove("my-class");
          id2.classList.remove("my-class");
          id3.classList.remove("my-class");
        });
        subMenuUnit.classList.add("my-class", "shift_right");
      }

      const fuellevel1 = document.getElementsByClassName("fuelMenuDashBoard");
      for (const fuelinit1 of fuellevel1) {
        fuelinit1.addEventListener("mouseover", () => {
          fuelinit1.classList.add("my-class_with-border");
        });
        fuelinit1.addEventListener("mouseout", () => {
          fuelinit1.classList.remove("my-class_with-border");
        });
        fuelinit1.classList.add("my-class", "shift_right");
      }
    });
  };

  // const reportDropDown = document.getElementById("reportMenuBar");
  // console.log(reportDropDown)

  // reportDropDown.addEventListener("mouseover",()=>{
  //     let reportSubMenus=document.getElementsByClassName("reportSubMenu")

  //     for (const subMenuElement of reportSubMenus) {
  //         subMenuElement.classList.add("my-class_with-border")
  //     }
  // })

  const mouseOutHandlerForReports = () => {
    // let reportmainMenu=document.getElementsByClassName("dropdown")[0]
    // reportmainMenu.classList.remove("my-class")
  };

  const mouseOverForReportHandler = () => {
    let reportmainMenu = document.getElementsByClassName("dropdown")[0];
    reportmainMenu.classList.add("my-class");

    let reportSubMenuContainer =
      document.getElementsByClassName("showDivReport")[0];

    let reportSubMenus = document.getElementsByClassName("reportSubMenu");

    for (const subReportUnit of reportSubMenus) {
      subReportUnit.addEventListener("mouseover", () => {
        reportSubMenuContainer.classList.add("my-class");
        subReportUnit.classList.add("only-border");
      });
      subReportUnit.addEventListener("mouseout", () => {
        subReportUnit.classList.remove("only-border");
      });
    }

    // reportSubMenuContainer.addEventListener("mouseover",()=>{

    // })
    reportSubMenuContainer.addEventListener("mouseout", () => {
      reportmainMenu.classList.remove("my-class");
    });
  };

  // const handleMouseOverAddClass = () => {
  //     alert('Hey')
  // }

  // let navLinkHover = document.getElementsByClassName("navlink")
  // let dropdownNavLinkHover = document.getElementsByClassName("dropdownFuel")

  // for (const navLinkHoverItem of navLinkHover) {
  //     navLinkHoverItem.addEventListener("mouseover",()=>{
  //         navLinkHoverItem.classList.add("only-left-border")

  //     })
  //     navLinkHoverItem.addEventListener("mouseout",()=>{
  //         navLinkHoverItem.classList.remove("only-left-border")
  //     })
  // }
  console.log({ attendance, DriverAttendance });
  return (
    <div className="sidebar" style={{ zIndex: "101" }}>
      {localStorage.getItem("email") != "route@watsoo.com" && (
        <ul className="top-menu">
          {dashboardMenu && (
            <li className="navlink" onClick={() => handleClick("dashboard")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "dashboard"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={dashboardIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Dashboard{" "}
                </div>
              </div>
            </li>
          )}

          {masterConfigrs?.lockDeatails && LockDashboard && (
            <li
              className="navlink"
              onClick={() => handleClick("lockDashboard")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "lockDashboard"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={lockDashboardIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Lock Dashboard{" "}
                </div>
              </div>
            </li>
          )}

          {/* company management sept 5 */}
          {companyMenu &&
            localStorage.getItem("data") &&
            JSON.parse(localStorage.getItem("data")).userType.toUpperCase() ===
              "SUPER_ADMIN" && (
              <li
                className="navlink "
                onClick={() => handleClick("companylist")}
              >
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] == "companylist"
                          ? 1
                          : 0.5,
                    }}
                    className="ml-1"
                    src={companyIcon}
                    alt="Company"
                  />
                  <div className="text-white ml-2 font-weight-bolder">
                    Company Management{" "}
                  </div>
                </div>
              </li>
            )}
          {/* company management end */}

          {viewAllUserPermission &&
          viewAllUserPermission.length > 0 &&
          userMenu ? (
            <li className="navlink " onClick={() => handleClick("userlist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "userlist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  User Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {/* role management */}
          {viewAllUserPermission &&
          viewAllUserPermission.length > 0 &&
          sidemenu ? (
            <li className="navlink " onClick={() => handleClick("rolelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "userlist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Menu Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* end */}

          {viewAllVendorPermission &&
          viewAllVendorPermission.length > 0 &&
          vendorMenu ? (
            <li
              className="navlink "
              onClick={() => handleClick("transporterlist")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "transporterlist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={vendorIcon}
                  alt="Transporter"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  {masterConfigrs?.transporterTitle} Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {DriverAttendance && DriverAttendance.length > 0 && attendance ? (
            <li
              className="navlink "
              onClick={() => handleClick("driverAttendance")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "driverAttendance"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={attendanceIcon}
                  alt="Attendance"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Driver Attendance{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {viewAllSitePermission &&
          viewAllSitePermission?.length > 0 &&
          siteMenu ? (
            <li className="navlink " onClick={() => handleClick("sitelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "sitelist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1 pl-1"
                  src={siteIcon}
                  alt="site"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Site Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {masterConfigrs?.lockDeatails && lockInventory ? (
            <li
              className="navlink "
              onClick={() => handleClick("LockInventory")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "LockInventory"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={LockInventory}
                  alt="vehicle"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Lock Inventory{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {masterConfigrs?.lockDeatails && alertList ? (
            <li className="navlink " onClick={() => handleClick("AlertList")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "AlertList"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={notificationIcon}
                  alt="vehicle"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Alert List{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {viewAllVehiclePermission &&
          viewAllVehiclePermission.length > 0 &&
          vehicleMenu ? (
            <li className="navlink " onClick={() => handleClick("vehiclelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "vehiclelist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={carIcon}
                  alt="vehicle"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Vehicle Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {viewAllVehiclePermission &&
          viewAllVehiclePermission.length > 0 &&
          advanceSettings ? (
            <li
              className="navlink "
              onClick={() => handleClick("advance-settings")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "advance-settings"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={settingIcon}
                  alt="settings"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Advance Settings{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {viewAllRoutePermission &&
          viewAllRoutePermission?.length > 0 &&
          routeMenu ? (
            <li className="navlink " onClick={() => handleClick("routelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "routelist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={routeIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Route Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {trackMenu && (
            <li className="navlink " onClick={() => handleClick("history/0")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "history"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={TrackHistoryIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Track History{" "}
                </div>
              </div>
            </li>
          )}

          {viewAllTripPermission &&
          viewAllTripPermission?.length > 0 &&
          tripMenu ? (
            <li className="navlink " onClick={() => handleClick("triplist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "triplist"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={tripIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Trip Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {viewAllTripPermission &&
          viewAllTripPermission?.length > 0 &&
          notificationMenu ? (
            <li
              className="navlink "
              onClick={() => handleClick("notificationConfigure")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "notificationConfigure"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={notificationIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Notification Configuration{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {
            // DriverManagement &&
            // DriverManagement?.length > 0 &&
            DriverManagementSystem ? (
              <li className="navlink " onClick={() => dmsHandleClick()}>
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] === "dms"
                          ? 1
                          : 0.5,
                    }}
                    className="ml-1"
                    src={DriverManagemenIcon}
                    alt="route"
                  />
                  <div className="text-white ml-2 font-weight-bolder">DMS </div>
                </div>
              </li>
            ) : (
              ""
            )
          }

          {manualEvent ? (
            <li
              className="navlink "
              onClick={() => handleClick("manualFuelEvents/0")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ===
                      "manualFuelEvents/0"
                        ? 1
                        : 0.5,
                  }}
                  className="ml-1"
                  src={manualFuelEventsIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Manual Fuel Events{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {localStorage.getItem("fuelEnable") === "true" &&
            viewAllReportPermission &&
            viewAllReportPermission?.length > 0 &&
            fuelMenu && (
              <li
                className="navlink dropdownFuel"
                onMouseOut={mouseOutHandler}
                style={
                  parentMenuColor ? { color: "orange" } : { color: "white" }
                }
              >
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ==
                          "fuelreport" &&
                        window.location.pathname.split("/")[1] ==
                          "fuelDashboard"
                          ? 1
                          : 0.5,
                    }}
                    className="ml-1"
                    src={fuelmanagementIcon}
                    alt="route"
                  />
                  <div className="text-white ml-2 font-weight-bolder">
                    Fuel Management{" "}
                  </div>
                </div>

                {/* DropDown */}

                <ul className="showDivFuel">
                  <li
                    className="text-white navlink fuelMenuDashBoard"
                    // onClick={() => handleClick("fuelDashboardDetails")}
                    onClick={() => handleClick("fuelDashboard")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=fuelDashboard"
                              ? 1
                              : 0.5,
                        }}
                        src={dashboardIcon}
                        alt="route"
                      />
                      <div className="text-white ml-1 pl-3 font-weight-bolder">
                        {" "}
                        Fuel Dashboard{" "}
                      </div>
                    </div>
                  </li>
                  {devaitionDetails && (
                    <li
                      className="text-white navlink fuelMenuDashBoard"
                      onClick={() => handleClick("deviationMaster")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "type=deviationMaster"
                                ? 1
                                : 0.5,
                          }}
                          src={FuelDeviationMaster}
                          alt="route"
                        />
                        <div className="text-white ml-1 pl-3 font-weight-bolder">
                          {" "}
                          Deviation Master{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {reportConfig && (
                    <li
                      className="text-white navlink fuelMenuDashBoard"
                      onClick={() => handleClick("reportConfig")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "type=reportConfig"
                                ? 1
                                : 0.5,
                          }}
                          src={ReportSettingConfigIcon}
                          alt="route"
                        />
                        <div className="text-white ml-1 pl-3 font-weight-bolder">
                          {" "}
                          Report Configuration{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {dieselIssue && (
                    <li
                      className="text-white navlink fuelMenuDashBoard"
                      onClick={() => handleClick("Diesel_issue")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "type=Diesel_issue"
                                ? 1
                                : 0.5,
                          }}
                          src={fuelmanagementIcon}
                          alt="route"
                        />
                        <div className="text-white ml-1 pl-3 font-weight-bolder">
                          {" "}
                          Diesel Issue
                        </div>
                      </div>
                    </li>
                  )}

                  {viewAllReportPermission &&
                    viewAllReportPermission?.length > 0 &&
                    fuelReport && (
                      <li className="navlink dropdownFuel fuelMenuDashBoard text-white">
                        <div className="innerList">
                          <img
                            style={{
                              opacity:
                                window.location.pathname.split("/")[1] ==
                                  "fuelreport" ||
                                window.location.pathname.split("/")[1] ==
                                  "fuelreport"
                                  ? 1
                                  : 0.5,
                            }}
                            className="ml-1"
                            src={fuelmanagementIcon}
                            alt="route"
                          />
                          <div className="text-white ml-1 pl-3 font-weight-bolder">
                            Fuel Reports{" "}
                          </div>
                        </div>
                        <ul className="innerShowDivFuel">
                          {fuelFillReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=FUELFILL")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELFILL"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelFillReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Fuel Fill Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {dropageRegulator && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick(
                                  "fuelreport?type=FUELDROPPAGEREGULATOR",
                                )
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELDROPPAGEREGULATOR"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelFillReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  Fuel Droppage Regulator
                                </div>
                              </div>
                            </li>
                          )}
                          {fuelDroppageReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=FUELDROP")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELDROP"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelDroppageReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Fuel Droppage Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {gpsWirecutReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=FUELWIRECUT")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELWIRECUT"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={GPSWirecutReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Gps Wirecut Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {gpsEventReportsReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick(
                                  "fuelreport?type=EVENTAPPORVALREPORT",
                                )
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=EVENTAPPORVALREPORT"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={reportIcon}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Event Approver Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {eventAnlayzer && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=EVENTANALYZER")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=EVENTANALYZER"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={reportIcon}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Event Analyzer{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {autoApprovalEventReports && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick(
                                  "fuelreport?type=AUTOAPPROVALEVENTREPORT",
                                )
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=AUTOAPPROVALEVENTREPORT"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={reportIcon}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Auto Approval Event Report{" "}
                                </div>
                              </div>
                            </li>
                          )}

                          {fuelSensorWirecut && true && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=FUELSENSORERROR")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "fuelreport?type=FUELSENSORERROR"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelSensorWirecutReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  Fuel Sensor Wirecut Report
                                </div>
                              </div>
                            </li>
                          )}
                          {/* {sensorCutVehicles &&
                        localStorage.getItem("getsensordata") && (
                          <li
                            className="text-white navlink fuelReportSubmenu"
                            onClick={() =>
                              handleClick("fuelreport?type=SENSORWIRECUT")
                            }
                          >
                            <div className="innerList">
                              <img
                                style={{
                                  opacity:
                                    window.location.search.split("?")[1] ==
                                    "fuelreport?type=SENSORWIRECUT"
                                      ? 1
                                      : 0.5,
                                }}
                                src={reportIcon}
                                alt="route"
                              />
                              <div className="text-white pl-4 font-weight-bolder">
                                Sensor Wirecut Report
                              </div>
                            </div>
                          </li>
                        )}

                        */}
                          {fuelSummaryReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=FUELSUMMARY")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELSUMMARY"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelSummaryReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  Fuel Summary Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {/* {deviceHavingIssued && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=DEVICEHAVINGISSUED")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=DEVICEHAVINGISSUED"
                                    ? 1
                                    : 0.5,
                              }}
                              src={FuelSummaryReport}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              Device Having Issued{" "}
                            </div>
                          </div>
                        </li>
                      )}  */}
                          {OffendedDriver && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelreport?type=OFFENDED_DRIVER")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=OFFENDED_DRIVER"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={OffendedDriverIcon}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  Offended Driver{" "}
                                </div>
                              </div>
                            </li>
                          )}

                          {/* {fuelCalibartionReports && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() =>
                                handleClick("fuelCalibrationReports")
                              }
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "fuelCalibrationReports"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={CalibrationIcon}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                Fuel Calibration Reports{" "}
                                </div>
                              </div>
                            </li>
                          )} */}

                          {/* {sensorCutVehicles && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=CONSUMPTION")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "fuelreport?type=CONSUMPTION"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              Fuel Consumption Report
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {localStorage.getItem("getsensordata") && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() => handleClick("SensorWirecut")}
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=SensorWirecut"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Sensor Cut Vehicles
                            </div>
                          </div>
                        </li>
                      )} */}

                          {fuelGraphMisReport && (
                            <li
                              className="text-white navlink fuelReportSubmenu"
                              onClick={() => handleClick("fuelDetails/0")}
                            >
                              <div className="innerList">
                                <img
                                  style={{
                                    opacity:
                                      window.location.search.split("?")[1] ==
                                      "type=FUELGRAPH"
                                        ? 1
                                        : 0.5,
                                  }}
                                  src={FuelGraphMISReport}
                                  alt="route"
                                />
                                <div className="text-white pl-4 font-weight-bolder">
                                  {" "}
                                  Fuel Graph MIS Report{" "}
                                </div>
                              </div>
                            </li>
                          )}
                          {/* {fuelEffiencyMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELEFFICIENCY&subType=FEMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELEFFICIENCY&subType=FEMISREPORT"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Efficiency MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {expectedVsActualReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELALERT&subType=EVAFMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELALERT&EVAFMISREPORT"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Expected Vs Actual Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {fuelConsumptionReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=KMDMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELSUMMARY&subType=KMDMISREPORT"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Consumption Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {fuelMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=FUELMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELSUMMARY&subType=FUELMISREPORT"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {alertMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=alertType")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=ODOMETER"
                                    ? 1
                                    : 0.5,
                              }}
                              src={AlertMISReport }
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Alert MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                          {/* {combineFuelReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELFILLDROPCOMBINEDREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELFILLDROPCOMBINEDREPORT"
                                    ? 1
                                    : 0.5,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Combine Fuel Report{" "}
                            </div>
                          </div>
                        </li>
                      )} */}
                        </ul>
                      </li>
                    )}
                </ul>

                {/* DropDownEnd */}
              </li>
            )}

          {/* {viewAllReportPermission &&
            viewAllReportPermission?.length > 0 &&
            menuPermission && (
              <li
                className="navlink "
                onClick={() => handleClick("menuPermission")}
              >
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ==
                        "menuPermission"
                          ? 1
                          : 0.5,
                      filter: "brightness(63%)",
                    }}
                    className="ml-1"
                    src={menuPermissionIcon}
                    alt="User"
                  />
                  <div className="text-white ml-2 font-weight-bolder">
                    Menu Permission{" "}
                  </div>
                </div>
              </li>
            )} */}

          {viewAllReportPermission &&
            viewAllReportPermission?.length > 0 &&
            reportMenu && (
              <li
                className="navlink dropdown dropdownFuel"
                id="reportMenuBar"
                onMouseOut={mouseOutHandlerForReports}
              >
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] ===
                          "reportsgps" ||
                        window.location.pathname.split("/")[1] === "reports"
                          ? 1
                          : 0.5,
                    }}
                    className="ml-1"
                    src={reportIcon}
                    alt="route"
                  />
                  <div className="text-white ml-2 font-weight-bolder">
                    Reports{" "}
                  </div>
                </div>
                <ul className="showDivFuel">
                  {/* {summaryReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("Summary")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Summary"
                              ? 1
                              : 0.5,
                        }}
                        src={SummaryIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Summary Report{" "}
                      </div>
                    </div>
                  </li>
                )} */}
                  {movementReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("Movement")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "type=running"
                                ? 1
                                : 0.5,
                          }}
                          src={RunningIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Movement Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {/* {stoppageReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=Stoppage")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Stoppage"
                              ? 1
                              : 0.5,
                        }}
                        src={StoppageIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Stoppage Report{" "}
                      </div>
                    </div>
                  </li>
                )} */}
                  {overSpeedReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("reports?type=overspeed")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "type=overspeed"
                                ? 1
                                : 0.5,
                          }}
                          src={OverSpeedIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Over Speed Report{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {/* {geofenceReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=GeoFenceDetail")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=GeoFenceDetail"
                              ? 1
                              : 0.5,
                        }}
                        src={OverSpeedIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Geofence Report{" "}
                      </div>
                    </div>
                  </li>
                )} */}
                  {/* {routeDeviationReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=routedeviation")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=routedeviation"
                              ? 1
                              : 0.5,
                        }}
                        src={RouteDevationIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Route Deviation Report{" "}
                      </div>
                    </div>
                  </li>
                )} */}
                  {/* {tamperingReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=Tampering")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Tempering"
                              ? 1
                              : 0.5,
                        }}
                        src={TemparingIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Tampering Report{" "}
                      </div>
                    </div>
                  </li>
                )} */}
                  {auditLog && viewAllReportAuditPermission.length > 0 && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("audit")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] == "audit"
                                ? 1
                                : 0.5,
                          }}
                          src={activeLogIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Audit Log{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {activeRoutes &&
                    viewAllReportActiveRoutesPermission &&
                    viewAllReportActiveRoutesPermission?.length > 0 && (
                      <li
                        className="text-white navlink reportSubMenu"
                        onClick={() => handleClick("activeRoutes")}
                      >
                        <div className="innerList">
                          <img
                            style={{
                              opacity:
                                window.location.search.split("?")[1] ==
                                "activeRoutes"
                                  ? 1
                                  : 0.5,
                            }}
                            src={activeRouteIcon}
                            alt="route"
                          />
                          <div className="text-white pl-2 font-weight-bolder">
                            {" "}
                            Active Routes{" "}
                          </div>
                        </div>
                      </li>
                    )}

                  {localStorage.getItem("email") === "watsoo@watsoo.com" && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("upTime")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] === "upTime"
                                ? 1
                                : 0.5,
                          }}
                          src={uptimeIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Up Time Report{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {gpsReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("reportsgps")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "reportsgps"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          GPS Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {permissionAccess?.companyId === 38 && LoadSensorReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("bulkerReport")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "bulkerReport"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Bulker Loading Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {dailyDistanceReopts && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("DailyDistance")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "DailyDistance"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Distance Report{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {EfficienlyReports && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("EfficiencyReports?type=All")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "type=All"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Efficiency Report{" "}
                        </div>
                      </div>
                    </li>
                  )}
                  {dayEfficienlyReports && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() =>
                        handleClick("EfficiencyReports?type=DayWise")
                      }
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "type=DayWise"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Day Efficiency Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {weeklyEfficienlyReports && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() =>
                        handleClick("EfficiencyReports?type=weekly")
                      }
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "type=weekly"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Weekly Efficiency Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {equipmentReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("equipment")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "equipment"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Equipment Summary Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {equipmentUtilization && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("equipmentUtilization")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "equipmentUtilization"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Equipment Utilization Report{" "}
                        </div>
                      </div>
                    </li>
                  )}

                  {GeoFenceInoutReport && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("geofence")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.pathname.split("/")[1] ===
                              "type=geofence"
                                ? 1
                                : 0.5,
                          }}
                          src={GpsIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          Geofence Report{" "}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </li>
            )}

          {/* <li className='showDivReport' onMouseOver={mouseOverForReportHandler} onMouseOut={mouseOutHandlerForReports}>
                    
    </li> */}
        </ul>
      )}

      {localStorage.getItem("email") === "route@watsoo.com" && (
        <div className="navlink " onClick={() => handleClick("routelist")}>
          <div style={{ width: "20px" }}>
            {" "}
            <img
              style={{
                opacity:
                  window.location.pathname.split("/")[1] === "routelist"
                    ? 1
                    : 0.5,
              }}
              className="ml-1"
              src={routeIcon}
              alt="route"
            />
          </div>
          <div className="text-white ml-2 font-weight-bolder">
            Route Management{" "}
          </div>
        </div>
      )}

      <div style={{ position: "fixed", bottom: "0" }}>
        <div className=" ">
          <div></div>
          <div
            className="text-white font-weight-bolder text-center ml-1"
            style={{ fontSize: "10px" }}
          >
            Version {version}{" "}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
